import { SVGProps } from './types';

const VerifiedCheckIcon = (props: SVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="9"
    height="9"
    fill="none"
    viewBox="0 0 9 9"
    {...props}
  >
    <g clipPath="url(#clip0_2776_52398)">
      <path
        fill="#1570EF"
        d="M6.468 1.483c.08.193.232.345.424.425l.674.28a.785.785 0 0 1 .425 1.025l-.279.674a.78.78 0 0 0 0 .601l.279.674a.785.785 0 0 1-.425 1.026l-.674.279a.79.79 0 0 0-.425.424l-.28.675a.785.785 0 0 1-1.025.424l-.674-.279a.79.79 0 0 0-.6 0l-.675.28a.785.785 0 0 1-1.025-.425l-.28-.674a.79.79 0 0 0-.424-.425l-.674-.28a.785.785 0 0 1-.425-1.025l.28-.674a.79.79 0 0 0-.001-.6l-.279-.675A.785.785 0 0 1 .81 2.187l.674-.28a.79.79 0 0 0 .425-.423L2.188.81A.785.785 0 0 1 3.214.385l.674.279c.192.08.408.08.6 0l.675-.279A.785.785 0 0 1 6.188.81l.28.674"
      ></path>
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M5.828 3.09a.393.393 0 0 0-.663-.422L3.628 5.084l-.704-.88a.393.393 0 0 0-.613.49l1.046 1.31a.393.393 0 0 0 .639-.035z"
        clipRule="evenodd"
      ></path>
    </g>
    <defs>
      <clipPath id="clip0_2776_52398">
        <path fill="#fff" d="M0 0h8.375v8.375H0z"></path>
      </clipPath>
    </defs>
  </svg>
);

export { VerifiedCheckIcon };
